//Search
export const IDI_INSPECTOR_DETAIL_SEARCH_START_LOADING = "IDI_INSPECTOR_DETAIL_SEARCH_START_LOADING";
export const IDI_INSPECTOR_DETAIL_SEARCH_END_LOADING = "IDI_INSPECTOR_DETAIL_SEARCH_END_LOADING";
export const IDI_INSPECTOR_DETAIL_SEARCH_LOADED = "IDI_INSPECTOR_DETAIL_SEARCH_LOADED";
export const SET_IDI_INSPECTOR_DETAIL_FILTER = "SET_IDI_INSPECTOR_DETAIL_FILTER";

//Edit
export const IDI_INSPECTOR_DETAIL_START_LOADING = "IDI_INSPECTOR_DETAIL_START_LOADING";
export const IDI_INSPECTOR_DETAIL_END_LOADING = "IDI_INSPECTOR_DETAIL_END_LOADING";
export const IDI_INSPECTOR_DETAIL_LOADED = "IDI_INSPECTOR_DETAIL_LOADED";
